let children = [];

//codigo edgar
children.push({
  path: "/asistenciatecnica/TiposdeCertificaciones",
  name: "ATS_TYPECERT",
  component: () => import("../views/TechnicalAssistance/typeCertification/TypeCertificationVG.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Asistencia Técnica", disabled: true },
      {
        text: "Tipos de Certificaciones",
        href: "/asistenciatecnica/Tipos de Certificaciones",
      },
    ],
  },
});
children.push({
  path: "/asistenciatecnica/VisitasConInsumosNoPermitidos",
  name: "ATS_VISITSNA",
  component: () => import("../views/TechnicalAssistance/TechnicalVisitSNA/TechnicalVisitSNAVG.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Asistencia Técnica", disabled: true },
      {
        text: "Visitas con Insumos no Permitidos",
        href: "/asistenciatecnica/Visitas con Insumos no Permitidos",
      },
    ],
  },
});
children.push({
  path: "/asistenciatecnica/MargenesNegociacion",
  name: "ATS_MARGIN",
  component: () => import("../views/TechnicalAssistance/MarginPrice/MarginPriceVG.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Asistencia Técnica", disabled: true },
      {
        text: "Margenes de Negociacion",
        href: "/asistenciatecnica/Margenes de Negociacion",
      },
    ],
  },
});
children.push({
  path: "/asistenciatecnica/Plagas",
  name: "ATS_PLAGAS",
  component: () => import("../views/TechnicalAssistance/Plagues/PlaguesVG.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Asistencia Técnica", disabled: true },
      { text: "Tipos de Plagas", href: "/asistenciatecnica/Tipos de Plagas" },
    ],
  },
});
children.push({
  path: "/asistenciatecnica/Visitasg",
  name: "TAS_VISIT_G",
  component: () => import("../views/TechnicalAssistance/Visits/VisitsG.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Asistencia Técnica", disabled: true },
      { text: "Visitas", href: "/asistenciatecnica/Visitasg" },
    ],
  },
});
children.push({
  path: "/asistenciatecnica/TiposVisitasTecnicas",
  name: "ATS_ASSIGNMATERIALTECHNICALVISIT",
  component: () => import("../views/TechnicalAssistance/AsignMaterialTechVisit.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Asistencia Técnica", disabled: true },
      {
        text: "Tipos de Visita Técnica",
        href: "/asistenciatecnica/Tipos de Visita Técnica",
      },
    ],
  },
});

children.push({
  path: "/asistenciatecnica/ListSupplies",
  name: "ATS_SUPPLIES",
  component: () => import("../views/TechnicalAssistance/ListSupplies/ListSuppliesVG.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Asistencia Técnica", disabled: true },
      { text: "Lista de Insumos", href: "/asistenciatecnica/Lista de Insumos" },
    ],
  },
});
children.push({
  path: "/asistenciatecnica/CategorizationPago",
  name: "ATS_CATEGORIZATION",
  component: () => import("../views/TechnicalAssistance/Categorization/CategorizationPaymentVG.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Asistencia Técnica", disabled: true },
      {
        text: "Categorias de Pagos",
        href: "/asistenciatecnica/CategorizationPago",
      },
    ],
  },
});

children.push({
  path: "/asistenciatecnica/zonas",
  name: "ATS_ZONAS",
  component: () => import("../views/TechnicalAssistance/Zone/ZoneSubzoneVG.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Asistencia Tecnica", disabled: true },
      { text: "Zonas", href: "/asistenciatecnica/zonas" },
    ],
  },
});

children.push({
  path: "/asistenciatecnica/proyecciones_semanales",
  name: "ATS_WEEKLY_SCREENINGS",
  component: () => import("../views/TechnicalAssistance/WeeklyProjection.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Asistencia Tecnica", disabled: true },
      {
        text: "Proyecciones Semanales",
        href: "/asistenciatecnica/proyecciones_semanales",
      },
    ],
  },
});

children.push({
  path: "/asistenciatecnica/visitasTecnicas",
  name: "ATS_TECHNICALVISIT",
  component: () => import("../views/TechnicalAssistance/TechnicalVisit/TechnicalVisitVG.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Asistencia Tecnica", disabled: true },
      { text: "Visitas Tecnicas", href: "/asistenciatecnica/visitasTecnicas" },
    ],
  },
});

children.push({
  path: "/asistenciatecnica/calendarioVisitasTecnicas",
  name: "ATS_TECHNICALVISITCALENDAR",
  component: () => import("../views/TechnicalAssistance/TechnicalVisit/Calendar.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Asistencia Tecnica", disabled: true },
      {
        text: "Calendario de Visitas Tecnicas",
        href: "/asistenciatecnica/calendarioVisitasTecnicas",
      },
    ],
  },
});

//fin codigo edgar
children.push({
  path: "/asistenciatecnica/vehiculo",
  name: "MNG_VEHICLE_AT",
  component: () =>
    /* import ("../views/Management/Vehicle/Vehicle.vue"), */
    import("../views/TechnicalAssistance/Vehicles/Vehicle.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Asistencia Técnica", disabled: true },
      {
        text: "Vehículo",
        href: "/asistenciatecnica/vehiculo",
      },
    ],
  },
});

children.push({
  path: "/asistenciatecnica/administrarAprobacionesVehiculos",
  name: "ATS_VEHICLE_APPROVAL",
  component: () => import("../views/Management/Vehicle/ManagementApprovalVehicle.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Asistencia Técnica", disabled: true },
      { text: "Administrar Aprobaciones de Vehículos", href: "/asistenciatecnica/administrarAprobacionesVehiculos" },
    ],
  },
});

children.push({
  path: "/asistenciatecnica/variedades",
  name: "ATS_VARIETY",
  component: () => import("../views/TechnicalAssistance/Variety/VarietyVG.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Asistencia Técnica", disabled: true },
      { text: "Variedades", href: "/asistenciatecnica/variedades" },
    ],
  },
});

//fin codigo edgar

children.push({
  path: "/asistenciatecnica/productor",
  name: "TAS_PRODUCER",
  component: () => import("../views/TechnicalAssistance/ProducersFarms/Producer.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Asistencia Técnica", disabled: true },
      { text: "Productores", href: "/asistenciatecnica/productor" },
    ],
  },
});

children.push({
  path: "/asistenciatecnica/productor_contract",
  name: "TAS_PRODUCER_CONTRACT",
  component: () => import("../views/TechnicalAssistance/ProducersFarms/ProducerContract.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Asistencia Técnica", disabled: true },
      {
        text: "Contrato de Productores",
        href: "/asistenciatecnica/productor_contract",
      },
    ],
  },
});

children.push({
  path: "/asistenciatecnica/proveedoresaprobados",
  name: "TAS_APPROVED_PROVIDERS",
  component: () => import("../views/TechnicalAssistance/ProducersFarms/approvedProviders.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Asistencia Técnica", disabled: true },
      {
        text: "Proveedores aprobados",
        href: "/asistenciatecnica/proveedoresaprobados",
      },
    ],
  },
});

children.push({
  path: "/asistenciatecnica/certificacion",
  name: "ATS_CERTIFICATION",
  component: () => import("../views/TechnicalAssistance/Certification.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Asistencia Técnica", disabled: true },
      { text: "Certificación", href: "/asistenciatecnica/certificacion" },
    ],
  },
});
children.push({
  path: "/asistenciatecnica/digitador",
  name: "ATS_DIGITADOR",
  component: () => import("../views/TechnicalAssistance/ProducersFarms/ProducersFarms_G.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Asistencia Técnica", disabled: true },
      { text: "Digitador", href: "/asistenciatecnica/digitador" },
    ],
  },
});
children.push({
  path: "/asistenciatecnica/preprogramacioncampana",
  name: "STS_HARVESTPRESCHEDULE",
  component: () => import("../views/TechnicalAssistance/HarvestSchedule/HarvestPreSchedule.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Asistencia Técnica", disabled: true },
      {
        text: "Pre-Programación Campaña",
        href: "/asistenciatecnica/preprogramacioncampana",
      },
    ],
  },
});
children.push({
  path: "/asistenciatecnica/programacioncampana",
  name: "STS_HARVESTSCHEDULE",
  component: () => import("../views/TechnicalAssistance/HarvestSchedule/HarvestSchedule.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Asistencia Técnica", disabled: true },
      {
        text: "Programación Campaña",
        href: "/asistenciatecnica/programacioncampana",
      },
    ],
  },
});
children.push({
  path: "/asistenciatecnica/Asignacionchofervehiculo",
  name: "STS_ASSISTEMENTDRIVERVEHICLE",
  component: () => import("../views/TechnicalAssistance/AssistementDriverVehicle/AssistementDriverVehicle.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Asistencia Técnica", disabled: true },
      {
        text: "Asignación Chofer Vehículo",
        href: "/asistenciatecnica/Asignacionchofervehiculo",
      },
    ],
  },
});
children.push({
  path: "/asistenciatecnica/AsignacionSupervisorCapataz",
  name: "ASF_ASIGNMENTSUPERVISEFOREMAN",
  component: () => import("../views/TechnicalAssistance/AsignmentSuperviceForeman/AsignmentSuperviceForeman.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Asistencia Tecnica", disabled: true },
      {
        text: "Asignación Supervisor Capataz",
        href: "/asistenciatecnica/AsignacionSupervisorCapataz",
      },
    ],
  },
});
children.push({
  path: "/carga/SAP",
  name: "SAP_LOAD",
  component: () => import("../views/TechnicalAssistance/SapLoad.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Asistencia Técnica", disabled: true },
      { text: "Carga SAP", href: "/asistenciatecnica/cargasap" },
    ],
  },
});

children.push({
  path: "/asistenciatecnica/asignmentcultivematerial",
  name: "ASF_ASIGNMENTCULTIVEMATERIAL",
  component: () => import("../views/TechnicalAssistance/CultiveMaterial.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Asistencia Tecnica", disabled: true },
      {
        text: "Asignación Cultivo Material",
        href: "/asistenciatecnica/asignmentcultivematerial",
      },
    ],
  },
});

children.push({
  path: "/asistenciatecnica/commitmentcarriermaterial",
  name: "AS_COMMITMENTCARRIERMATERIAL",
  component: () => import("../views/TechnicalAssistance/CommitmentCarrierMaterial/CommitmentCarrierMaterial.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Asistencia Tecnica", disabled: true },
      {
        text: "Compromiso Transportista Material",
        href: "/asistenciatecnica/commitmentcarriermaterial",
      },
    ],
  },
});

children.push({
  path: "/asistenciatecnica/inputoutputmaterial",
  name: "AS_INPUTOUTPUTMATERIAL",
  component: () => import("../views/TechnicalAssistance/InputOutputMaterial/InputOutputMaterial.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Asistencia Ténica", disabled: true },
      { text: "Entrada Salida de Materiales", href: "/asistenciatecnica/" },
    ],
  },
});

children.push({
  path: "/asistenciatecnica/ConfiguracionVehicle",
  name: "CONFIG_VEHICLE",
  component: () => import("../views/TechnicalAssistance/ConfiguracionVehicle/ConfigVehicle.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Asistencia Tecnica", disabled: true },
      {
        text: "Configuración Vehículo",
        href: "/asistenciatecnica/ConfiguracionVehicle",
      },
    ],
  },
});
children.push({
  path: "/asistenciatecnica/ConfigurationPrice",
  name: "CONFIG_PRICE",
  component: () => import("../views/TechnicalAssistance/ConfigurationPrice/ConfigPrice.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Asistencia Tecnica", disabled: true },
      {
        text: "Configuración Precios",
        href: "/asistenciatecnica/ConfigurationPrice",
      },
    ],
  },
});

children.push({
  path: "/asistenciatecnica/AssignmentPrice",
  name: "ASSIGN_PRICE",
  component: () => import("../views/TechnicalAssistance/ConfigurationPrice/AssignmentPrice.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Asistencia Tecnica", disabled: true },
      {
        text: "Asignación de Precios",
        href: "/asistenciatecnica/AssignmentPrice",
      },
    ],
  },
});

children.push({
  path: "/asistenciatecnica/MangoPriceAssignmentDemo",
  name: "MANGO_PRICE_ASSIGNMENT_DEMO",
  component: () => import("../views/TechnicalAssistance/ConfigurationPrice/MangoPriceAssignmentDemo.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Asistencia Tecnica", disabled: true },
      {
        text: "Proyección Asignación Precios Mango (Demo)",
        href: "/asistenciatecnica/MangoPriceAssignmentDemo",
      },
    ],
  },
});

children.push({
  path: "/asistenciatecnica/HarvestSchedulePriceApproval",
  name: "HARVEST_SCHEDULE_PRICE_APPROVAL",
  component: () => import("../views/TechnicalAssistance/HarvestSchedulePriceApproval/HarvestSchedulePriceApproval.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Asistencia Técnica", disabled: true },
      {
        text: "Aprobación de Precios de Cosecha",
        href: "/asistenciatecnica/HarvestSchedulePriceApproval",
      },
    ],
  },
});


children.push({
  path: "/asistenciatecnica/certificationschedule",
  name: "AS_CERTIFICATIONSCHEDULE",
  component: () => import("../views/TechnicalAssistance/CertificationSchedule/CertificationSchedule.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Asistencia Tecnica", disabled: true },
      {
        text: "Cronograma de Certificaciones",
        href: "/asistenciatecnica/certificationschedule",
      },
    ],
  },
});
children.push({
  path: "/asistenciatecnica/visitas",
  name: "TAS_VISIT",
  component: () => import("../views/TechnicalAssistance/Visits/Visit.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Asistencia Tecnica", disabled: true },
      {
        text: "Visitas",
        href: "../views/TechnicalAssistance/Visits/Visit.vue",
      },
    ],
  },
});

children.push({
  path: "/asistenciaTecnica/cosecha/recepcion-vigilancia",
  name: "ATS_RECEPCTIONSURVEILLANCE",
  component: () => import("../views/TechnicalAssistance/ReceptionSurveillance/ReceptionSurveillance.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Asistencia Técnica", disabled: true },
      { text: "Cosecha", disabled: true },
      {
        text: "Recepción vigilancia",
        href: "/asistenciaTecnica/cosecha/recepcion-vigilancia",
      },
    ],
  },
});

children.push({
  path: "/asistenciaTecnica/cosecha/visitas-a-productores",
  name: "ATS_VISIT_TO_PRODUCERS",
  component: () => import("../views/TechnicalAssistance/HarvestSchedule/VisitsToProducers.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Asistencia Técnica", disabled: true },
      { text: "Cosecha", disabled: true },
      {
        text: "Visita a Productores",
        href: "/asistenciaTecnica/cosecha/visitas-a-productores",
      },
    ],
  },
});

children.push({
  path: "/technicalassistance/payment_scheduling",
  name: "ATS_PAYMENTSCHEDULING",
  component: () => import("../views/TechnicalAssistance/PaymentScheduling/PaymentScheduling.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Asistencia Técnica", disabled: true },
      {
        text: "Programación de Pagos",
        href: "/technicalassistance/payment_scheduling",
      },
    ],
  },
});

// Ruta Leyner
children.push({
  path: "/asistenciaTecnica/adelanto-productor",
  name: "ATS_ADVANCEPRODUCER",
  component: () => import("../views/TechnicalAssistance/AdvanceProducer/AdvanceProducer.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Asistencia Técnica", disabled: true },
      {
        text: "Adelanto de Insumos",
        href: "/asistenciaTecnica/adelanto-productor",
      },
    ],
  },
});

children.push({
  path: "/asistenciatecnica/CrewsAssistance",
  name: "ATS_CrewsAssistance",
  component: () => import("../views/TechnicalAssistance/CrewsAssistance/CrewsAssistance.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Asistencia Tecnica", disabled: true },
      {
        text: "Asistencia Cuadrilla",
        href: "/asistenciatecnica/CrewsAssistance",
      },
    ],
  },
});

children.push({
  path: "/asistenciatecnica/ConfigurationKmZon",
  name: "ATS_KM_ZON_TRANSPORT",
  component: () => import("../views/TechnicalAssistance/TransportConfiguration/TransportZonKm.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Asistencia Tecnica", disabled: true },
      {
        text: "Configuracion de Km - Zona",
        href: "/asistenciatecnica/TransportZonKm",
      },
    ],
  },
});

children.push({
  path: "/asistenciatecnica/TransportPrice",
  name: "ATS_TRANSPORT_PRICE",
  component: () => import("../views/TechnicalAssistance/TransportConfiguration/TransportPrice.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Asistencia Tecnica", disabled: true },
      { text: "Precios", href: "/asistenciatecnica/TransportPrice" },
    ],
  },
});

children.push({
  path: "/asistenciatecnica/GeneratePaymentTransport",
  name: "ATS_GENERATE_PAYMENT_TRANSPORT",
  component: () => import("../views/TechnicalAssistance/TransportConfiguration/TransportPaymentNew.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Asistencia Tecnica", disabled: true },
      { text: "Generar Pago Transportistas", href: "/asistenciatecnica/GeneratePaymentTransport" },
    ],
  },
});
children.push({
  path: "/asistenciatecnica/TransportPaymentRecords",
  name: "ATS_TRANSPORT_PAYMENT_RECORDS",
  component: () => import("../views/TechnicalAssistance/TransportConfiguration/TransportPaymentRecord.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Asistencia Tecnica", disabled: true },
      { text: "Pagos Registrados Transportistas", href: "/asistenciatecnica/TransportPaymentRecords" },
    ],
  },
});
children.push({
  path: "/asistenciatecnica/ExtraTransport",
  name: "ATS_TRANSPORT_EXTRAS",
  component: () => import("../views/TechnicalAssistance/ExtraTransport/ExtraTransport.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Asistencia Tecnica", disabled: true },
      { text: "Transporte Extra", href: "/asistenciatecnica/ExtraTransport" },
    ],
  },
});

children.push({
  path: "/asistenciatecnica/warehouseentrance",
  name: "ATS_WAREHOUSEENTRANCE",
  component: () => import("../views/TechnicalAssistance/WarehouseEntrance/Warehouse.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Asistencia Tecnica", disabled: true },
      { text: "Almacén", href: "/asistenciatecnica/warehouseentrance" },
    ],
  },
});

children.push({
  path: "/asistenciatecnica/warehouse",
  name: "ATS_WAREHOUSES",
  component: () => import("../views/TechnicalAssistance/Warehouse/Warehouse.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Asistencia Tecnica", disabled: true },
      { text: "Almacén", href: "/asistenciatecnica/warehouse" },
    ],
  },
});

children.push({
  path: "/asistenciatecnica/ConfigurationCoste",
  name: "ATS_CONFIG_COSTE",
  component: () => import("../views/TechnicalAssistance/TransportConfiguration/ConfigurationCoste.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Asistencia Tecnica", disabled: true },
      {
        text: "Configuracion Costo",
        href: "/asistenciatecnica/ConfigurationCoste",
      },
    ],
  },
});

children.push({
  path: "/asistenciatecnica/ProgrammingStorage",
  name: "ATS_PROGRAMMING",
  component: () => import("../views/TechnicalAssistance/ProgrammingStorage/ProgrammingStorage.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Asistencia Tecnica", disabled: true },
      {
        text: "Programacion Acopio",
        href: "/asistenciatecnica/ProgrammingStorage",
      },
    ],
  },
});

children.push({
  path: "/asistenciatecnica/ReceptionStorage",
  name: "ATS_RECEPTION_STORAGE",
  component: () => import("../views/TechnicalAssistance/ProgrammingStorage/ReceptionStorage.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Asistencia Tecnica", disabled: true },
      { text: "Recepcion Acopio", href: "/asistenciatecnica/ReceptionStorage" },
    ],
  },
});

children.push({
  path: "/asistenciatecnica/AssignLicenseVehicle",
  name: "ATS_AssignLicenseVehicle",
  component: () => import("../views/TechnicalAssistance/AssignLicenseVehicle/AssignLicenseVehicle.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Asistencia Tecnica", disabled: true },
      {
        text: "Asignar Categoria Brevete con Vehiculo",
        href: "/asistenciatecnica/AssignLicenseVehicle",
      },
    ],
  },
});
children.push({
  path: "/asistenciatecnica/cultivoarticulo",
  name: "ATS_ASIGNMENTARTICLECULTIVE",
  component: () => import("../views/TechnicalAssistance/MaintainerCropArticleSap/MaintainerCropArticle.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Asistencia Técnica", disabled: true },
      {
        text: "Cultivo Artículos SAP",
        href: "/asistenciatecnica/cultivoarticulo",
      },
    ],
  },
});

children.push({
  path: "/asistenciatecnica/MaintainerSector",
  name: "ATS_MAINTAINERSECTOR",
  component: () => import("../views/TechnicalAssistance/MaintainerSector/MaintainerSectorSubSector.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Asistencia Técnica", disabled: true },
      {
        text: "Mantenedor Sector",
        href: "/asistenciatecnica/MaintainerSector",
      },
    ],
  },
});

children.push({
  path: "/asistenciatecnica/TransportParameters",
  name: "ATS_TRANSPORT_PARAMETERS",
  component: () => import("../views/TechnicalAssistance/TransportConfiguration/TransportParameters.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Asistencia Técnica", disabled: true },
      { text: "Parametros", href: "/asistenciatecnica/TransportParameters" },
    ],
  },
});

children.push({
  path: "/asistenciatecnica/ZonGroup",
  name: "TAS_GROUP_ZON",
  component: () => import("../views/TechnicalAssistance/ZonGroup/ZonGroup.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Asistencia Técnica", disabled: true },
      { text: "Grupo Zonas", href: "/asistenciatecnica/ZonGroup" },
    ],
  },
});

children.push({
  path: "/asistenciatecnica/trucktransportcost",
  name: "TAS_TRUCK_TRANSPORT_COST",
  component: () => import("../views/TechnicalAssistance/TruckTransportCost/TruckTransportCost.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Asistencia Técnica", disabled: true },
      {
        text: "Costo Transporte Camión",
        href: "/asistenciatecnica/trucktransportcost",
      },
    ],
  },
});

children.push({
  path: "/asistenciatecnica/transfertruck",
  name: "TAS_TRANSFER_TRUCK",
  component: () => import("../views/TechnicalAssistance/TransferTruck/TransferTruck.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Asistencia Técnica", disabled: true },
      { text: "Transbordo", href: "/asistenciatecnica/transfertruck" },
    ],
  },
});

children.push({
  path: "/asistenciatecnica/reports",
  name: "TAS_REPORT_TECH_ASS",
  component: () => import("../views/TechnicalAssistance/Reports/Reports.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Asistencia Técnica", disabled: true },
      { text: "Reportes", href: "/asistenciatecnica/reports" },
    ],
  },
});

children.push({
  path: "/asistenciatecnica/imprimirformato",
  name: "ATS_RECEPTION_PLANT",
  component: () => import("../views/TechnicalAssistance/TransportConfiguration/ReceptionPlant.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Asistencia Tecnica", disabled: true },
      {
        text: "Recepcion de Fruta",
        href: "/asistenciatecnica/imprimirformato",
      },
    ],
  },
});

children.push({
  path: "/asistenciatecnica/analisismateria/analisis",
  name: "TAS_ANALYSIS_RAW_MATERIAL",
  component: () => import("../views/TechnicalAssistance/RawMaterialAnalysis/Analysis/RawMaterialAnalysis.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Asistencia Tecnica", disabled: true },
      { text: "Analisis de Materia Prima", disabled: true },
      { text: "Analisis", href: "/asistenciatecnica/analisismateria/analisis" },
    ],
  },
});

children.push({
  path: "/asistenciatecnica/analisismateria/alertascalidad",
  name: "TAS_QUALITY_ALERTS_RAW_MATERIAL",
  component: () => import("../views/TechnicalAssistance/RawMaterialAnalysis/QualityAlerts/QualityAlertsView.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Asistencia Tecnica", disabled: true },
      { text: "Analisis de Materia Prima", disabled: true },
      { text: "Alertas de Calidad", href: "/asistenciatecnica/analisismateria/alertascalidad" },
    ],
  },
});

children.push({
  path: "/asistenciatecnica/projections",
  name: "TAS_PROJECTIONS",
  component: () => import("../views/TechnicalAssistance/Projections/Projections.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Asistencia Tecnica", disabled: true },
      { text: "Proyecciones", href: "/asistenciatecnica/projections" },
    ],
  },
});

// Nueva ruta para selector de lotes con rutas
children.push({
  path: "/asistenciatecnica/lotes-rutas",
  name: "ATS_DIGITADOR_MAP",
  component: () => import("../views/TechnicalAssistance/ProducersFarms/LotRouteSelector.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Asistencia Técnica", disabled: true },
      {
        text: "Selector de Lotes y Rutas",
        href: "/asistenciatecnica/lotes-rutas",
      },
    ],
  },
});

// Alerts module
children.push({
  path: "/technical-assistance/alerts",
  name: "ATS_ALERTS",
  component: () => import("../views/TechnicalAssistance/Alert/AlertsG.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Asistencia Técnica", disabled: true },
      { text: "Alertas", href: "/technical-assistance/alerts" },
    ],
  },
});
// Alerts module
children.push({
  path: "/technical-assistance/charts/cantidad-Jabas",
  name: "ATS_CHART_HARVEST_JAVA_QUANTITY",
  component: () => import("../views/TechnicalAssistance/Projections/HarvestJavaQuantity.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Asistencia Técnica", disabled: true },
      { text: "cantida Jabas", href: "/technical-assistance/charts/cantidad-Jabas" },
    ],
  },
});
// Ruta de Parámetros de Materiales
children.push({
  path: "/asistenciatecnica/ParametrosDeMateriales",
  name: "ATS_PARAMS_MATERIALS",
  component: () => import("../views/TechnicalAssistance/TypeMaterial/ParamsTypeMaterial.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Asistencia Técnica", disabled: true },
      { text: "Parámetros de Materiales", href: "/asistenciatecnica/ParametrosDeMateriales" },
    ],
  },
});
children.push({
  path: "/asistenciatecnica/CalcularMateriales",
  name: "ATS_CALC_MATERIALS",
  component: () => import("../views/TechnicalAssistance/TypeMaterial/CalcularTypeMaterial.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Asistencia Técnica", disabled: true },
      { text: "Calcular Materiales", href: "/asistenciatecnica/CalcularMateriales" },
    ],
  },
});
children.push({
  path: "/asistenciatecnica/pago-transportistas-acopio",
  name: "ATS_PAYMENT_TRANSPORTERS_COLLECT",
  component: () => import("../views/TechnicalAssistance/PaymentTransportersCollect/PaymentTransportersCollect.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Asistencia Tecnica", disabled: true },
      {
        text: "Pago Transportistas Acopio",
        href: "/asistenciatecnica/pago-transportistas-acopio",
      },
    ],
  },
});
children.push({
  path: "/asistenciatecnica/VencimientoCertificaciones",
  name: "TAS_CERTIDICATION_EXPIRATION",
  component: () => import("../views/TechnicalAssistance/Certification/CertificationExpiredList.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Asistencia Técnica", disabled: true },
      { text: "Vencimiento de Certificaciones", href: "/asistenciatecnica/VencimientoCertificaciones" },
    ],
  },
});

children.push({
  path: "/asistenciatecnica/GestionDocumentarioProductores",
  name: "TAS_SUPPLIER_APPROVALS",
  component: () => import("../views/TechnicalAssistance/SupplierApprovals/SupplierApprovals.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Asistencia Técnica", disabled: true },
      { text: "Gestion Documentario Productores", href: "/asistenciatecnica/GestionDocumentarioProductores" },
    ],
  },
});

children.push({
  path: "/asistenciatecnica/ConfirmacionGestionDocumentarioProductores",
  name: "TAS_SUPPLIER_APPROVAL_CONFIRMATION",
  component: () => import("../views/TechnicalAssistance/SupplierApprovals/SupplierApprovalConfirmation.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Asistencia Técnica", disabled: true },
      { text: "Confirmacion Gestion Documentario Productores", href: "/asistenciatecnica/ConfirmacionGestionDocumentarioProductores" },
    ],
  },
});
children.push({
  path: "/asistenciatecnica/payment_transporters_history",
  name: "TAS_PAYMENT_TRANSPORTERS_HISTORY",
  component: () => import("../views/TechnicalAssistance/PaymentTransportersCollect/PaymentTransportersCollectHistory.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Asistencia Técnica", disabled: true },
      {
        text: "Historial de Pagos Procesados",
        href: "/asistenciatecnica/payment_transporters_history",
      },
    ],
  },
});

children.push({
  path: "/asistenciatecnica/ProducerCategorization",
  name: "TAS_PRODUCER_CATEGORIZATION",
  component: () => import("../views/TechnicalAssistance/ProducersFarms/ProducerCategorization.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Asistencia Técnica", disabled: true },
      {
        text: "Categorización de Productores",
        href: "/asistenciatecnica/ProducerCategorization",
      },
    ],
  },
});

children.push({
  path: "/asistenciatecnica/ReporteCompraInsumos",
  name: "TAS_INPUT_PURCHASE_FORECAST",
  component: () => import("../views/TechnicalAssistance/AdvanceProducer/InputPurchaseForecast.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Asistencia Técnica", disabled: true },
      {
        text: "Reporte Compra Insumos",
        href: "/asistenciatecnica/ReporteCompraInsumos",
      },
    ],
  },
});

children.push({
  path: "/asistenciatecnica/ProducerOldDebts",
  name: "TAS_PRODUCER_OLD_DEBTS",
  component: () => import("../views/TechnicalAssistance/ProducersFarms/ProducerOldDebts.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Asistencia Técnica", disabled: true },
      {
        text: "Deudas Antiguas",
        href: "/asistenciatecnica/ProducerOldDebts",
      },
    ],
  },
});

children.push({
  path: "/asistenciaTecnica/reporte-adelanto-productor",
  name: "TAS_ADVANCE_PRODUCER_REPORT",
  component: () => import("../views/TechnicalAssistance/AdvanceProducer/AdvanceProducerReport.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Asistencia Técnica", disabled: true },
      {
        text: "Reporte Adelantos de Productores",
        href: "/asistenciaTecnica/reporte-adelanto-productor",
      },
    ],
  },
});

children.push({
  path: "/asistenciaTecnica/reporte-pago-productores",
  name: "PROD_PAYMENT_REPORT",
  component: () => import("../views/TechnicalAssistance/TasProducerPaymentReport.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Asistencia Técnica", disabled: true },
      { text: "Reporte Pago a Productores", href: "/asistenciaTecnica/reporte-pago-productores" },
    ],
  },
});

children.push({
  path: "/asistenciaTecnica/reporte-deudas-productores",
  name: "PROD_DEBT_REPORT",
  component: () => import("../views/TechnicalAssistance/ProducerDebt/TasProducerDebtReport.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Asistencia Técnica", disabled: true },
      { text: "Reporte Deudas de Productores", href: "/asistenciaTecnica/reporte-deudas-productores" },
    ],
  },
});

children.push({
  path: "/asistenciaTecnica/AgriculturalEquipment",
  name: "TAS_AGRICULTURAL_EQUIPMENT",
  component: () => import("../views/TechnicalAssistance/AgriculturalEquipment/AgriculturalEquipment.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Asistencia Técnica", disabled: true },
      {
        text: "Equipo Agrícola",
        href: "/asistenciaTecnica/AgriculturalEquipment",
      },
    ],
  },
});

children.push({
  path: "/asistenciaTecnica/ReportTechnicalVisit",
  name: "REPORT_TECHNICAL_VISIT",
  component: () => import("../views/TechnicalAssistance/Reports/ReportTechnicalVisit.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Asistencia Técnica", disabled: true },
      {
        text: "Reporte de Visita Técnica",
        href: "/asistenciaTecnica/ReportTechnicalVisit",
      },
    ],
  },
});

children.push({
  path: "/asistenciatecnica/AreaWeather",
  name: "TAS_AREA_WEATHER",
  component: () =>
    import("../views/TechnicalAssistance/AreaWeather/AreaWeather.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Asistencia Técnica", disabled: true },
      {
        text: "Clima de Zona",
        href: "/asistenciatecnica/AreaWeather",
      },
    ],
  },
});

children.push({
  path: "/asistenciaTecnica/ReportVisitPerformedApplicationReal",
  name: "REPORT_VISIT_PERFORMED_APPLICATION_REAL",
  component: () =>
    import("../views/TechnicalAssistance/Reports/ReportVisitPerformedApplicationReal.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Asistencia Técnica", disabled: true },
      {
        text: "Reporte de Aplicaciones Reales",
        href: "/asistenciaTecnica/ReportVisitPerformedApplicationReal",
      },
    ],
  },
});

children.push({
  path: "/asistenciatecnica/WeeklyProjectionCalendar",
  name: "TAS_WEEKLY_PROJETION_CALENDAR",
  component: () => import("../views/TechnicalAssistance/WeeklyProjectionCalendar.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Asistencia Técnica", disabled: true },
      {
        text: "Calendario de Proyecciones Semanales",
        href: "/asistenciatecnica/WeeklyProjectionCalendar",
      },
    ],
  },
});

children.push({
  path: "/asistenciatecnica/WeeklyProjectionApproval",
  name: "TAS_WEEKLY_PROJECTION_APPROVAL",
  component: () => import("../views/TechnicalAssistance/WeeklyProjectionApproval.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Asistencia Técnica", disabled: true },
      {
        text: "Aprobación de Proyecciones Semanales",
        href: "/asistenciatecnica/WeeklyProjectionApproval",
      },
    ],
  },
});


children.push({
  path: "/asistenciatecnica/ActiveSubstances",
  name: "TAS_ACTIVE_SUBSTANCES",
  component: () => import("../views/TechnicalAssistance/Substances/Substances.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Asistencia Técnica", disabled: true },
      {
        text: "Sustancias",
        href: "/asistenciatecnica/ActiveSubstances",
      },
    ],
  },
});

children.push({
  path: "/asistenciatecnica/Substances",
  name: "TAS_SUBSTANCES",
  component: () => import("../views/TechnicalAssistance/Substances/Substances.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Asistencia Técnica", disabled: true },
      {
        text: "Sustancias",
        href: "/asistenciatecnica/Substances",
      },
    ],
  },
});

children.push({
  path: "/asistenciatecnica/MRLs",
  name: "TAS_MRLS",
  component: () => import("../views/TechnicalAssistance/MRLs/MRLs.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Asistencia Técnica", disabled: true },
      {
        text: "Límites Máximos de Residuos (LMR)",
        href: "/asistenciatecnica/MRLs",
      },
    ],
  },
});


children.push({
  path: "/asistenciatecnica/MRLAnalysisResult",
  name: "MRL_ANALYSIS_RESULT",
  component: () => import("../views/TechnicalAssistance/MRLs/MRLAnalysisResult.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Asistencia Técnica", disabled: true },
      {
        text: "LMR - Resultados de Análisis",
        href: "/asistenciatecnica/MRLAnalysisResult",
      },
    ],
  },
});



children.push({
  path: "/asistenciatecnica/seguimientoUTs",
  name: "ATS_TRACKING_UTS",
  component: () => import("../views/TechnicalAssistance/TrackingUT/TrackingUT.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Asistencia Técnica", disabled: true },
      {
        text: "Seguimiento de UTs",
        href: "/asistenciatecnica/seguimientoUTs",
      },
    ],
  },
});

children.push({
  path: "/asistenciatecnica/reporteAnalisisMateriaPrima",
  name: "ATS_RPT_RAWMATERIAL_ANALYSIS",
  component: () => import("../views/TechnicalAssistance/RawMaterialAnalysis/RawMaterialAnalysisReport.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Asistencia Técnica", disabled: true },
      {
        text: "Reporte de Análisis de MP",
        href: "/asistenciatecnica/reporteAnalisisMateriaPrima",
      },
    ],
  },
});

children.push({
  path: "/asistenciatecnica/reporteAprobacionMateriaPrima",
  name: "ATS_RPT_RAWMATERIAL_APPROVAL",
  component: () => import("../views/TechnicalAssistance/RawMaterialAnalysis/RawMaterialApprovalReport.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Asistencia Técnica", disabled: true },
      {
        text: "Reporte de Aprobación de MP",
        href: "/asistenciatecnica/reporteAprobacionMateriaPrima",
      },
    ],
  },
});

children.push({
  path: "/asistenciatecnica/WeeklyProjectionRequiresAnalysis",
  name: "TAS_WEEKLY_PROJECTION_REQUIRES_ANALYSIS",
  component: () => import("../views/TechnicalAssistance/WeeklyProjectionAnalysisRequirement.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Asistencia Técnica", disabled: true },
      {
        text: "Requerimiento de Análisis por Proyección",
        href: "/asistenciatecnica/WeeklyProjectionRequiresAnalysis",
      },
    ],
  },
});

children.push({
  path: "/asistenciatecnica/Mercados",
  name: "ATS_MARKETS",
  component: () => import("../views/TechnicalAssistance/Markets/MarketsVG.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Asistencia Técnica", disabled: true },
      {
        text: "Mercados y Sustancias",
        href: "/asistenciatecnica/Mercados",
      },
    ],
  },
});

export { children };
